import './styles/main.scss';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import {useEffect, useMemo, useState} from "react";
import InstallPage from "./pages/InstallPage";
import MainPage from "./pages/MainPage";
import RefreshResumePage from "./pages/RefreshResumePage";
import ChatPage from "./pages/ChatPage";
import Loading from "./elements/Loading";
import HhAuthorizePage from "./pages/HhAuthorizePage";
import HhChatAuthorizePage from "./pages/HhChatAuthorizePage";
import VacancySettingsPage from "./pages/VacancySettingsPage";
import ApplicantAnalysPage from "./pages/ApplicantAnalysPage";
import ResumeWorkspacePage from "./pages/ResumeWorkspacePage";
import getAPIClient from "./hooks/apiClient";

function App() {
    const [appInitialized, setAppInitialized] = useState(false)
    const [appLoaded, setAppLoaded] = useState(false)

    const BX24 = useMemo(() => {
        // Режим «зайти как портал» из админки: токен из URL прячем в sessionStorage
        // и убираем из адресной строки; BX24 не инициализируем — авторизацию
        // по этому токену собирает бэкенд
        const urlParams = new URLSearchParams(window.location.search)
        const impersonationToken = urlParams.get('impersonation_token')
        if (impersonationToken) {
            sessionStorage.setItem('impersonation_token', impersonationToken)
            urlParams.delete('impersonation_token')
            const qs = urlParams.toString()
            window.history.replaceState({}, '', window.location.pathname + (qs ? `?${qs}` : ''))
        }
        if (sessionStorage.getItem('impersonation_token')) {
            setAppInitialized(true)
            return
        }
        if (
            window.location.pathname.includes('hh_authorize') ||
            window.location.pathname.includes('hh_chat_authorize')
        ){
            setAppInitialized(true)
            return
        }
        const bx = window.BX24
        bx.init(() => setAppInitialized(true));
        return bx;
    }, [])

    useEffect(() => {
        if (!appInitialized) {
            return
        }
        if (
            window.location.pathname.includes('hh_authorize') ||
            window.location.pathname.includes('hh_chat_authorize') ||
            window.location.pathname.includes('install')
        ){
            setAppLoaded(true)
            return
        }
        const api = getAPIClient(BX24)
        api.get('/bitrix_portals/settings').then(() => {setAppLoaded(true)})
    }, [appInitialized])

    if (!appLoaded) {
        return <Loading isLoading={true}/>
    }
    const isImpersonation = Boolean(sessionStorage.getItem('impersonation_token'))
    return (
        <BrowserRouter>
            {isImpersonation && (
                <div style={{
                    position: 'sticky', top: 0, zIndex: 1000,
                    background: '#7e22ce', color: '#fff', padding: '6px 14px',
                    fontSize: '13px', textAlign: 'center', fontFamily: 'sans-serif'
                }}>
                    Режим администратора ResumeScan - вы управляете приложением от имени портала
                </div>
            )}
            <Routes>
                <Route exact path="/" element={<MainPage BX24={BX24}/>} />
                <Route exact path="/hh_authorize" element={<HhAuthorizePage/>} />
                <Route exact path="/install" element={<InstallPage BX24={BX24}/>} />
                <Route exact path="/update_crm_item" element={<RefreshResumePage BX24={BX24}/>} />
                <Route exact path="/vacancy_settings" element={<VacancySettingsPage BX24={BX24}/>} />
                <Route exact path="/applicant_analys" element={<ApplicantAnalysPage BX24={BX24}/> } />
                <Route exact path="/resume_workspace" element={<ResumeWorkspacePage BX24={BX24}/> } />
                <Route exact path="/resume_selection" element={<ResumeWorkspacePage BX24={BX24}/> } />
                <Route exact path="/resume_dashboard" element={<ResumeWorkspacePage BX24={BX24}/> } />
                <Route exact path="/chat" element={<ChatPage BX24={BX24}/>} />
                <Route exact path="/hh_chat_authorize" element={<HhChatAuthorizePage/>} />
            </Routes>
        </BrowserRouter>
    )
}

export default App;
